import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { toSignV3 } from '../utils/toSignV3';


/** 接口根路径，来自各环境 .env 中的 VUE_APP_BASE_URL；若走 devServer 代理可设为 '' */
const BASE_URL = process.env.VUE_APP_BASE_URL || '';

const service: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

const getBoxAgent = (obj) => {
  const param = Object.keys(obj);
  const data = Object.values(obj);
  let sign = "";
  param.forEach((item, index) => {
      const val = data[index] === undefined ? "" : data[index];
      sign += `${item}:${val};`;
  });
  return sign;
}


service.interceptors.request.use(
  async (config) => {
    const timestamp = new Date().getTime();
    if (config.method === 'get') {
      const args = config.params;
      // 不加会提示签名不正常
      config.url = config.url
      + (config.url && config.url.indexOf("?") == -1 ? "?" : "&") + `rqtime=${timestamp}` + "&" + 'rqrandom=' + "&" + 'sign='
      + (args ? '&' + Object.keys(args).map(key => `${key}=${args[key]}`).join('&') : '');
      config.params = {};
    }

    const signObj = {
      method: config.method,
      url: config.url,
      deviceType: "pc",
      deviceId: "",
      appv: "5.0.1",
      token: ""
    }

    const sign = await toSignV3({}, signObj)

    config.headers['X-BOX-AUTHORIZATION'] = sign;
    config.headers.device = signObj.deviceType;
    config.headers.deviceId = signObj.deviceId;
    config.headers.appv = signObj.appv;
    config.headers.token = signObj.token;
    config.headers['Box-Agent'] = getBoxAgent({
      appv: signObj.appv,
      deviceId: signObj.deviceId,
      device: signObj.deviceType,
      isEmbedded: true,
      embedded: "web",
    })

    return config
  },
  (error) => Promise.reject(error),
);

service.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => Promise.reject(error),
);

/** 与 axios 同参，返回完整 AxiosResponse */
export function request<T = unknown>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
  return service.request<T>(config);
}

export { BASE_URL, service };
export default service;
